// extracted by mini-css-extract-plugin
export default {"otp":"index_otp__rzYu7","signpreview":"index_signpreview__Z2GUq"};